// Sized for the selection/actions row plus pagination. All dashboard rows
// inherit this width and scroll together on smaller screens.
export const JOBS_CONTENT_MIN_WIDTH = 1400;

// Align the first control in the filter and selection rows.
export const JOBS_TOOLBAR_BUTTON_WIDTH = 128;
